import React from 'react';
import PropTypes from 'prop-types';

export default class Contact extends React.PureComponent {
  static propTypes = {
    entry: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
  }

  state = {
    entry: this.props.entry,
    data: this.props.data,
    contactData: null, // Initialize contactData as null
  };

  componentDidMount() {
    // Process data when component mounts if available
    if (this.state.data && this.state.data.length > 0) {
      this.processContactData();
    }
  }

  componentDidUpdate(prevProps) {
    // Check if data prop has been updated
    if (prevProps.data !== this.props.data && this.props.data.length > 0) {
      this.setState({ data: this.props.data }, () => {
        this.processContactData();
      });
    }
  }

  processContactData() {
    const data = this.state.data;
    const contact = data.filter(entry => entry.sys.id === this.state.entry);
    if (contact && contact.length > 0) {
      this.setState({ contactData: contact[0].fields });
    }
  }

  render() {
    // Only try to render data if it's available
    const { contactData } = this.state;
    
    // Add loading state while waiting for data
    if (!contactData) {
      return (
        <div className="contact-item">
          <p>Loading contact information...</p>
        </div>
      );
    }
    
    const contactName = contactData.name;
    const contactTitle = contactData.title;
    const contactEmail = contactData.email;
    const contactPhone = contactData.phone;
    const contactPhoto = contactData.photo.fields.file.url + '?w=500&h=400&fm=jpg&q=100';
    
    return (
      <div className="contact-item">
        <img
          className="contact-photo"
          alt={contactName}
          src={contactPhoto}
          loading="lazy"
        />
        <div className="contact-info">
          <strong className="contact-name">{contactName}</strong><br/>
          {contactTitle}<br/>
          <a href={`mailto:${contactEmail}`}>{contactEmail}</a><br/>
          {contactPhone}
        </div>
      </div>
    );
  }
}
